import { render, staticRenderFns } from "./class-remote-select.vue?vue&type=template&id=6fc08fa2"
import script from "./class-remote-select.vue?vue&type=script&lang=js"
export * from "./class-remote-select.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports